// src/utils/printHelper.js
export const printSection = (elementId) => {
  const el = document.getElementById(elementId);
  if (!el) return;
  const win = window.open('', '_blank');
  win.document.write(`
    <html><head>
      <title>印刷</title>
      <style>
        body { font-family: 'Hiragino Sans', 'Meiryo', sans-serif; font-size: 11px; }
        table { width: 100%; border-collapse: collapse; }
        td, th { border: 1px solid #999; padding: 4px 8px; }
        th { background: #f0f0f0; }
        .amount { text-align: right; }
        .total { font-weight: bold; background: #f5f5f5; }
        @media print { button { display: none; } }
      </style>
    </head><body>
      ${el.innerHTML}
    </body></html>
  `);
  win.document.close();
  win.focus();
  win.print();
};
